import { Context, Middleware } from '@nuxt/types'
import { Routes } from '~/constants'

const requiredOfferMiddleware: Middleware = ({ store, redirect }: Context) => {
  if (store.state.anket.offer === null) redirect(Routes.RESULT)
}

export default requiredOfferMiddleware
